module.exports = __webpack_public_path__ + "img/icon-mw.807b652a.svg";